import { render } from "./NewStudentRow.vue?vue&type=template&id=98c61906&scoped=true"
import script from "./NewStudentRow.vue?vue&type=script&lang=js"
export * from "./NewStudentRow.vue?vue&type=script&lang=js"

import "./NewStudentRow.vue?vue&type=style&index=0&id=98c61906&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c61906"]])

export default __exports__